import { serviceHost } from '../../common/const';
import ServiceRequest from '../../utils/service-request';

export const regenerateXml = async (data) => {
    try {
        let response = await ServiceRequest('post', 'json', serviceHost + '/xml/regenerateXml', data);
        return { response, err: null };
    }
    catch (err) {
        if (err) {
            return { response: null, err };
        }
    };
}

export const generateContactXml = async (data) => {
    try {
        let response = await ServiceRequest('post', 'json', serviceHost + '/xml/generateContactXml',data);
        return { response, err: null };
    }
    catch (err) {
        if (err) {
            return { response: null, err };
        }
    };
}

export const generateAddressXml = async (data) => {
    try {
        let response = await ServiceRequest('post', 'json', serviceHost + '/xml/generateAddressXml', data);
        return { response, err: null };
    }
    catch (err) {
        if (err) {
            return { response: null, err };
        }
    };
}

export const generateBankXml = async (data) => {
    try {
        let response = await ServiceRequest('post', 'json', serviceHost + '/xml/generateBankXml', data);
        return { response, err: null };
    }
    catch (err) {
        if (err) {
            return { response: null, err };
        }
    };
}

export const generateCSXml = async (data) => {
    try {
        let response = await ServiceRequest('post', 'json', serviceHost + '/xml/generateCSXml' ,data);
        return { response, err: null };
    }
    catch (err) {
        if (err) {
            return { response: null, err };
        }
    };
}

export const regenerateCFSMAGXml = async (data) => {
    try {
        let response = await ServiceRequest('post', 'json', serviceHost + '/xml/regenerateCFSMAGXml', data);
        return { response, err: null };
    }
    catch (err) {
        if (err) {
            return { response: null, err };
        }
    };
}